import React from "react";
import { buildWhatsAppUrl } from "../lib/whatsapp";

// Inline WhatsApp glyph (lucide doesn't ship one; this is a minimal stroked version)
const WhatsAppIcon = ({ className = "" }) => (
  <svg
    viewBox="0 0 24 24"
    aria-hidden="true"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.25"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <path d="M3 21l1.65-4.5A8.5 8.5 0 1 1 7.5 19.35L3 21z" />
    <path d="M8.5 9.5c.2 2 2 4 4 4l1-1.5c.3-.4.8-.5 1.2-.3l1.6.7c.4.2.6.7.5 1.1-.3 1.1-1.4 2-2.6 2-3.6 0-6.5-2.9-6.5-6.5 0-1.2.9-2.3 2-2.6.4-.1.9.1 1.1.5l.7 1.6c.2.4.1.9-.3 1.2L9 8.5z" />
  </svg>
);

export const WhatsAppButton = ({
  message = "",
  children,
  className = "",
  size = "default",
  testId = "whatsapp-button",
  variant = "gold",
}) => {
  const href = buildWhatsAppUrl(message);

  const base =
    "inline-flex items-center justify-center gap-3 rounded-none uppercase tracking-[0.18em] font-medium transition-all duration-300 group";
  const variants = {
    gold:
      "bg-[#C5A059] text-white hover:bg-[#9A7B3E] border border-[#C5A059] hover:border-[#9A7B3E]",
    outline:
      "bg-transparent text-black border border-black hover:bg-black hover:text-white",
    dark:
      "bg-black text-white border border-black hover:bg-[#C5A059] hover:border-[#C5A059]",
  };
  const sizes = {
    sm: "text-[10px] py-3 px-5",
    default: "text-xs py-4 px-8",
    lg: "text-xs md:text-sm py-5 px-10",
    full: "text-xs py-5 px-8 w-full",
  };

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId}
      className={`${base} ${variants[variant]} ${sizes[size]} ${className}`}
    >
      <WhatsAppIcon className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5" />
      <span>{children}</span>
    </a>
  );
};

export default WhatsAppButton;
